import http from "./http-common";

class NotificationService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) => (key && payload[key] ? key + "=" + payload[key] : ""))
      .join("&");
  }
  GetFavMedicineList(payload) {
    var queryString = this.queryString(payload);
    return http.get(`/userFavouriteMedicine/list/filter?${queryString}`);
  }

  SaveFavMedicine(payload) {
    return http.post(`/userFavouriteMedicine/save`, payload);
  }

  RemoveFavMedicine(payload) {
    return http.put(`/userFavouriteMedicine/update`, payload);
  }
}

export default new NotificationService();
